import React from 'react'

function FormError({message, subMessage}) {
  return (
    <div class="mb-2 lg:mb-6 flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 shadow-sm">
                    
                    <div class="mt-0.5 flex h-6 w-6 items-center justify-center rounded-full bg-red-100">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-red-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M12 9v2m0 4h.01M12 3a9 9 0 100 18 9 9 0 000-18z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h4 class="text-xs lg:text-sm font-semibold text-red-700">
                        {message}
                      </h4>
                      <p class="mt-1 text-xs lg:text-sm text-red-600">
                        {subMessage}
                      </p>
                    </div>
                  </div>
  )
}

export default FormError
